import { inject, Pipe, PipeTransform } from '@angular/core';

import { Permission } from '../../types/permission.type';
import { UserService } from '../../user/user.service';

@Pipe({
  name: 'permission',
  standalone: true,
  pure: false,
})
export class PermissionPipe implements PipeTransform {
  #userService = inject(UserService);

  transform(requiredPermission: Permission): boolean {
    return this.#userService.checkHasPermission(requiredPermission);
  }
}
